import { render, staticRenderFns } from "./EmbedBlockModal.vue?vue&type=template&id=3c97a13a"
import script from "./EmbedBlockModal.vue?vue&type=script&lang=js"
export * from "./EmbedBlockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports